import _ts_decorate from "@swc/helpers/src/_ts_decorate.mjs";
import _ts_metadata from "@swc/helpers/src/_ts_metadata.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { FormUI } from "@parkschannel/ui";
import { useTripPlanerContext } from "../TripPlannerContext";
import { useForm } from "react-hook-form";
import { Form, Input } from "../../../Forms";
import classNames from "classnames";
import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { IsNotEmpty, IsString } from "class-validator";
class UpsertPlan {
}
_ts_decorate([
    IsString(),
    IsNotEmpty(),
    _ts_metadata("design:type", String)
], UpsertPlan.prototype, "name", void 0);
export const PlannerNameForm = (param)=>{
    let { renderButtons  } = param;
    const { planner  } = useTripPlanerContext();
    const methods = useForm({
        resolver: classValidatorResolver(UpsertPlan),
        defaultValues: {
            name: planner.name
        }
    });
    const { handleSubmit , formState: { errors  }  } = methods;
    return /*#__PURE__*/ _jsx(Form.Form, {
        methods: methods,
        submitButton: ()=>{
            return renderButtons === null || renderButtons === void 0 ? void 0 : renderButtons(handleSubmit);
        },
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs(Form.Field, {
                name: "name",
                children: [
                    /*#__PURE__*/ _jsx(FormUI.Label, {
                        htmlFor: "name",
                        children: "Name of the trip plan:"
                    }),
                    /*#__PURE__*/ _jsx(Input.TextAreaField, {
                        maxLength: 150,
                        rows: 3,
                        placeholder: "Type short and encouraging name",
                        className: classNames({
                            "!border-red-500": !!errors.name
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormUI.ErrorMessage, {
                        error: errors.name
                    })
                ]
            })
        })
    });
};
